import * as React from 'react';
export const kriyaSvg = React.forwardRef(function kriyaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.452 7.41 14.34.262c.087-.103.01-.262-.123-.262h-3.25a.308.308 0 0 0-.246.118L4.116 8.134c-.02.025-.056.01-.056-.021V.164A.16.16 0 0 0 3.9.005H1.16a.16.16 0 0 0-.16.16V15.84a.16.16 0 0 0 .159.159H3.9a.16.16 0 0 0 .159-.16v-2.864c0-.15.05-.293.148-.411l1.645-1.998h.006c.42-.539 1.004-.842 1.68-.852.882-.015 1.671.544 2.03 1.35l2.086 4.74c.051.118.164.19.292.19h2.89a.16.16 0 0 0 .15-.226l-2.804-6.357c-.625-1.386-1.88-2.454-3.731-2.002Z',
    }),
  );
});
kriyaSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var kriya = {
  category: 'paymentmethod',
  colorable: true,
  name: 'kriya',
  svg: kriyaSvg,
};
